import {environment} from '../../constants-enumerate';
import {RotationsService} from '../../rotations-service';

export default () => {
  return RotationsService.rotationRequalifyCheck(() => {
    return !environment.IN_APP;
  }, false);
};
